module.exports = __webpack_public_path__ + "9cb686bee5e886747ad24b644470bea0.svg";